import { useCallback, type FC } from "react";
import { TextButton } from "@root/shared/components/TextButton";
import * as styles from "./styles.css";

type Props = {
  className?: string;
};

const TARGET_ID = "other-work-cassettes-outer";

export const OtherWorksLink: FC<Props> = ({ className }) => {
  const handleOnClick = useCallback(() => {
    const target =
      document.getElementById(TARGET_ID) ||
      (document.getElementsByName(TARGET_ID).length
        ? document.getElementsByName(TARGET_ID)[0]
        : null);

    if (!target) {
      return;
    }

    const navHeight = window.innerWidth < 768 ? 42 : 48;
    const top = target.getBoundingClientRect().top + window.pageYOffset - navHeight;

    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    // Aタグでの画面内遷移と挙動を揃えるため
    window.history.pushState(null, "", `#${TARGET_ID}`);
  }, []);

  return (
    <div className={`${styles.otherWorksOuter} ${className ?? ""}`}>
      <p>この企業には他にも求人/店舗があります</p>
      <TextButton
        type="button"
        size="large"
        rightIconName="arrow-bold-down"
        isBold
        className={styles.otherWorksLink}
        onClick={handleOnClick}
      >
        もっと見る
      </TextButton>
    </div>
  );
};
